export const INIT_FINISHED = 'INIT_FINISHED';
export const INIT_FAIL = 'INIT_FAIL';
export const INIT_SUCCESS = 'INIT_SUCCESS';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const SELECT_CABIN = 'SELECT_CABIN';
